document.addEventListener('DOMContentLoaded', function(){ 
    const checkout = document.querySelector('#checkout');
    if(checkout) {  
      checkout.addEventListener('click', function (event) {
        event.preventDefault();
        const giftForm = document.querySelector('#gift-option-form') || null;
        const donationForm = document.querySelector('#donation-option-form') || null;
        const recommendationForm = document.querySelector('#recommendations-form') || null;
        const selectedGiftOption = giftForm?.querySelector('#gift-option-checkbox:checked')?.value;
        const selectedDonationOption = donationForm?.querySelector('#donation-option-checkbox:checked')?.value;
        const selectedRecommendedOption = recommendationForm?.querySelector('input[name="recommendation-option"]:checked')?.value;        
        const itemsToAdd = [];
        console.log('Here: ', itemsToAdd, selectedGiftOption)
        if (selectedGiftOption) {
          itemsToAdd.push({
            id: selectedGiftOption,
            quantity: 1
          });
        }
        if (selectedDonationOption) {
          itemsToAdd.push({
            id: selectedDonationOption,
            quantity: 1
          });
        }
        if (selectedRecommendedOption) {
          itemsToAdd.push({
            id: selectedRecommendedOption,
            quantity: 1
          });
        }
  
        if (itemsToAdd.length > 0) {
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              'items': itemsToAdd
            })
          })
          .then(function(response) {
            return response.json();
          })
          .then(function(data) {      
            console.log('Success');
            window.location.href = '/checkout';
          })
          .catch(function(error) {
            console.error('Error:', error);
          });     
          
        } else {
          window.location.href = '/checkout';
        }
      });
    }   
  });
  